import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes, multiLangType} from "../common/enums/ExcelEnum";
import {LangType} from "../common/enums/ContentEnum";

const logPrefix  = "[EvenStepSixStore]"
export default class EvenStepSixStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.isProcessing = false;
        this.popoverState = false;
        this.isDeleteFlag = false;
        this.speakingBoxRef = null;
        this.contentTapIndex = 0;
        this.contentList = [];
        this.selectedContent = [];
        this.translationContents = {};
        this.requestTranslations = [];
        this.audio = null;
        this.readyToSaveStep = false;
        this.stepValue = 0;
        this.dayValue = 0;

        makeAutoObservable(this);
    }

    initEvenStepSixContent = () => {
        this.isProcessing = false;
        this.popoverState = false;
        this.isDeleteFlag = false;
        this.speakingBoxRef = null;
        this.contentList = [];
        this.selectedContent = [];
        this.contentTapIndex = 0;
        this.translationContents = {};
        this.requestTranslations = [];
        this.audio = null;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }


    setReorderedContents = (contents, langeCode) => {
        this.contentList.filter(content => content.languageCode === langeCode)[0].contents = contents;
        this.contentStore.setReadyToSaveStep(this.isEvenStepSixCompleted());
        this.readyToSaveStep = this.isEvenStepSixCompleted();
    }

    setDeleteFlag = (flag) => {
        this.isDeleteFlag = flag;
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setSpeakingContentText = (value, index, contents) => {
        const reorderedContents = Array.from(contents);
        if (reorderedContents[index].text !== value) {
            reorderedContents[index].text = value;
            reorderedContents[index].audioExist = false;
            this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
        }
    }

    setVoiceTypeByIndex = (voiceType, index, ) => {
        this.contentList.forEach(content => {
            const reorderedContents = Array.from(content.contents);
            reorderedContents[index].voiceType = voiceType;
            reorderedContents[index].audioExist = false;
            reorderedContents[index].descriptionAudioExist = false;
            this.setReorderedContents(reorderedContents, content.languageCode);
        })

    }

    setBoldBatchChange = (contents, boldSearchText) => {
        const reorderedContents = Array.from(contents);
        reorderedContents.forEach((content, i) => {
            const startIndex = content.text.indexOf(boldSearchText);
            const endIndex = startIndex + boldSearchText.length;
            if (startIndex > -1) {
                reorderedContents[i].boldStartIndex = startIndex;
                reorderedContents[i].boldEndIndex = endIndex;
            }
        });
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
    }

    setSpeakingContentTextIndex = (start, end, index, contents) => {
        const reorderedContents = Array.from(contents);
        reorderedContents[index].boldStartIndex = start;
        reorderedContents[index].boldEndIndex = end;
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
    }

    setSpeakingContentAudio = (audio, index, contents) => {
        const reorderedContents = Array.from(contents);
        reorderedContents[index].audio = audio.split(',')[1];
        reorderedContents[index].audioExist = true;
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
    }

    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode())[0];
    }

    setTranslationContents = (translations) => {
        translations.sort((a, b) => multiLangType.indexOf(a.languageCode) - multiLangType.indexOf(b.languageCode)).forEach(content => {
            if (!this.translationContents[content.languageCode]) {
                this.translationContents[content.languageCode] = [];
            }
            this.translationContents[content.languageCode].push(content);
        });
    }

    setTranslateText = (text, index, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent[index].text = text;
        this.setTranslate(lang, index);
    }

    setTranslateDisplay = (isEnable, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent.forEach((c, index) => {
            c.enable = isEnable;
            this.setTranslate(lang, index);
        });
    }

    getAiTranslate = (lang) => {
        this.getSelectedContent(LangType.EN).forEach((c, i) => {
            this.contentStore.getGeneratedTranslate(lang, c.text, (translatedText) => this.setTranslateText(translatedText, i, lang));
        });
    }

    setTranslate = (lang, index) => {
        let translationContent = this.translationContents[lang].slice();
        const targetContent = translationContent[index];
        this.translationContents = {
            ...this.translationContents,
            [lang]: translationContent,
        };

        const contentIdx = this.requestTranslations.findIndex(r => r.id === targetContent.id);
        if (contentIdx === -1) {
            this.requestTranslations.push(targetContent);
        } else {
            this.requestTranslations[contentIdx] = targetContent;
        }
        this.contentStore.setReadyToSaveStep(this.isEvenStepSixCompleted() && !!this.requestTranslations.length);
        this.readyToSaveStep = this.isEvenStepSixCompleted() && !!this.requestTranslations.length;
    }

    setSpeakingBoxRef = (ref) => {
        this.speakingBoxRef = ref;
    }

    setPopoverState = (boolean) => {
        this.popoverState = boolean;
    }

    setProcessing = (processing) => {
        this.isProcessing = processing;
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    isEvenStepSixCompleted = () => {
        const mainLangContents = this.getSelectedContent(LangType.KO)[0];
        const {contents} = mainLangContents;
        if (mainLangContents.languageCode === 'KO') {
            const hasEmptyValues = contents.some(content => {
                return content.text === '' || content.voiceType === '';
            });
            return !hasEmptyValues;
        } else {
            return false;
        }
    }

    playAudio = (audio, id) => {
        if (this.audio && !this.audio.paused && this.audio.id === id) {
            this.stopAudio();
        } else {
            if (this.audio) {
                this.stopAudio();
            }
            const decodeAudio = atob(audio);
            const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], {type: 'audio/mp3'});
            this.audio = new Audio();
            this.audio.id = id;
            this.audio.src = URL.createObjectURL(blob);
            this.audio.play();
        }
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    convertRequestContents = () => {
        return this.contentList.map((c) => ({
            contentId: c.contentId,
            languageCode: c.languageCode,
            contents: c.contents.map((content, i) => {
                return ({
                    id : content.id,
                    sequence: i+1,
                    boldStartIndex: content.boldStartIndex,
                    boldEndIndex: content.boldEndIndex,
                    text: content.text,
                    voiceType: content.voiceType,
                });
            })
        })).sort((a, b) => langTypes.indexOf(a.languageCode) - langTypes.indexOf(b.languageCode));
    }


    * getEvenStepSixContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepSixContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/6`;
            const response = yield this.contentRepository.getContent(url);
            this.contentList = response.data;
            this.contentStore.setReadyToMoveExit(this.isEvenStepSixCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            this.setSelectedContent();
            console.log(logPrefix, 'Finished getEvenStepSixContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepSixContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepSixContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepSixContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/6?isDelete=${this.isDeleteFlag}`;
            const requestContents = this.convertRequestContents();
            console.log(logPrefix, 'modifyEvenStepSixContent requestContents :', requestContents);
            yield this.contentRepository.putContent(url, requestContents);
            console.log(logPrefix, 'Finished modifyEvenStepSixContent.');
            this.getEvenStepSixContent(step, day);
            // this.openErrorDialog({
            //     titleText: '저장 성공',
            //     text: displayErrorDialogPrompt('',  '컨텐츠를 정상적으로 저장하였습니다.')
            // });
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyEvenStepSixContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '본문 수정 작업중 에러가 발생했습니다.')
            });
        } finally {
            this.setDeleteFlag(false);
        }
    }


}

